// extracted by mini-css-extract-plugin
module.exports = {"container":"Alert_container__211Hh","containerInner":"Alert_containerInner__1_3Kh","richtext":"Alert_richtext__g66Bb","close":"Alert_close__1c4Kd"};